// After a BFCache restore (logout + browser Back), the stale authenticated DOM
// is shown without any HTTP request. The backend rotates a JS-readable
// `gl_logout_generation` cookie on every logout, so a restored page whose
// snapshot no longer matches the current cookie reloads once to pick up the
// logged-out state. The snapshot is updated before reloading, so repeated
// pageshow events for the same generation never reload more than once.
//
// Both the V1 and V2 bundles call this installer on authenticated layouts.
// Production builds those as separate entry bundles, so the installed flag is
// keyed on the target Window under a registered symbol (`Symbol.for`), ensuring
// every module instance in the realm shares one guard.
const INSTALLED = Symbol.for('GrowthLoop.logoutBfcacheGuard');

type Target = Window & typeof globalThis & {[INSTALLED]?: true};

export function installLogoutBfcacheGuard(
  target: Target = window as Target
): void {
  if (target[INSTALLED]) return;
  target[INSTALLED] = true;

  const pattern = /(?:^|;\s*)gl_logout_generation=([^;]*)/;
  let generation = target.document.cookie.match(pattern)?.[1];

  target.addEventListener('pageshow', (event: PageTransitionEvent) => {
    if (!event.persisted) return;
    const current = target.document.cookie.match(pattern)?.[1];
    if (current === generation) return;
    generation = current;
    target.location.reload();
  });
}
